import React,{useState, useEffect} from 'react';
import VfSlider from './components/VfSlider';
import './App.css';

import { API_URL, PREGUNTAS, DECK } from './config/general';
import GoLandscape from './components/GoLandscape';
import Loading from './components/Loading';

function App() {
  const [appSize, setAppSize] = useState([window.innerWidth,window.innerHeight]);
  const [preguntas, SetPreguntas] = useState([]);
  const [deck, SetDeck] = useState();

  const queryParameters = new URLSearchParams(window.location.search)
  const urldeck = queryParameters.get("deck")

  let deck_id = urldeck ? urldeck : 1;


  const handleResize = () => {
    setAppSize([window.innerWidth,window.innerHeight]);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);

  const getDeck = async () => {
    try {
      let response = await fetch(`${API_URL}${DECK}/${deck_id}`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      
      let data = await response.json();
      SetDeck(data);
    } catch (error) {
      // Handle the error
      console.error('Error fetching data:', error.message);
      // You can set an error state or perform other actions as needed
    }
  };

  const getPreguntas = async () => {
    try {
      let response = await fetch(`${API_URL}${PREGUNTAS}/${deck_id}`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      
      let data = await response.json();
      SetPreguntas(data);
    } catch (error) {
      // Handle the error
      console.error('Error fetching data:', error.message);
      // You can set an error state or perform other actions as needed
    }
  };

  getDeck();
  getPreguntas();
  
    // Cleanup: Remove event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [deck_id]);
  

  return (
    <div className="App">
      { appSize[1] > appSize[0] && deck ? <GoLandscape message={ deck.landcape_message } /> : ''}
      { preguntas[0] && deck ? <VfSlider size={ appSize } preguntas={ preguntas } deck={ deck }/> : <Loading />}
    </div>
  );
}

export default App;
